import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NodeEditor } from 'modules/workflows/components/NodeEditor';

import {
  fetchBetaNodesRequest,
  getBetaSupportedNodes,
  getNodeById,
  getNodeIsOpening,
  getNodeResources,
  getOpenedNodeData,
  getWorkflow,
} from '../ducks';
import { useFetchClonedFromNodeData } from '../hooks/useFetchClonedFromNodeData';
import { editorComponentByType } from './NodeEditor/nodeEditorUtils';

const EditorSidebarCmp = ({ workflowId, openedNodeId, canDraftMessaging }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // fetch the list of nodes that are supported in beta
    dispatch(fetchBetaNodesRequest());
  }, []);

  const isNodeOpening = useSelector(getNodeIsOpening);
  const openedNode = useSelector((state) => getNodeById(state, openedNodeId));
  const openedNodeData = useSelector(getOpenedNodeData);
  const openedNodeResources = useSelector((state) => getNodeResources(state, openedNodeId));
  const openedNodeWorkflowData = useSelector(getWorkflow);
  const betaNodes = useSelector(getBetaSupportedNodes);

  const { clonedFromNodeData = {}, isLoading = false } = useFetchClonedFromNodeData(
    openedNode?.id,
    openedNodeWorkflowData?.workflowType,
  );

  const editorProps = {
    betaNodes,
    node: openedNode,
    nodeData: openedNodeData,
    nodeId: openedNodeId,
    nodeType: openedNode.type,
    resources: openedNodeResources,
    workflowData: openedNodeWorkflowData,
    workflowId,
    clonedFromNodeData,
    isClonedFromNodeDataLoading: isLoading,
  };

  if (isNodeOpening) {
    return <NodeEditor canDraftMessaging={canDraftMessaging} {...editorProps} />;
  }

  const EditorComponent = editorComponentByType[openedNode?.type];

  return EditorComponent ? <EditorComponent {...editorProps} /> : null;
};

export const EditorSidebar = React.memo(EditorSidebarCmp);
export default EditorSidebar;
